<section id="form_page" class="container loading_container" [ngClass]="{ 'loaded' : rateForm }">
  <div class="loading_content">
    <div id="page_header">
      <h1>Produits</h1>
      <app-button (clickEvent)="goBack()" text="retour" [style]="'border blue'"></app-button>
    </div>
    <div id="form_wrapper">
      <h2>{{!ticketType ? "Crée" : "Éditer"}} un produit</h2>
      <form *ngIf="rateForm" [formGroup]="rateForm">
        <div class="form_cols">
          <div class="form_item full">
            <label for="name">Nom du produit</label>
            <input id="name" type="text" formControlName="name">
          </div>
          <div class="form_item full smaller_margin">
            <input id="free" type="checkbox" [checked]="freeTicket" (change)="changeFreeTicket()">
            <label for="free">
              Ce produit est gratuit
              <i class="check">
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </i>
            </label>
          </div>
          <ng-container *ngIf="!freeTicket">
            <div class="form_item half">
              <label for="price">Prix</label>
              <input id="price" (keyup)="changePrice($event.target.value)" type="number" formControlName="price">
              <ng-container *ngIf="price.user">

                <p *ngIf="!stripeInvalid; else noStripe"
                  class="description_medium info_commission">{{price.user || 0 | currency: 'EUR'}}
                  pour {{isAdmin ? "l'organisation" : "vous"}},
                  {{(price.commission + flatCommission) || 0 | currency: 'EUR'}} pour OandB .</p>
                <ng-template #noStripe>
                  <p *ngIf="!isAdmin" class="form_item error">Votre compte de paiement n'est pas valide. Pour le valider, suivez
                    <a routerLink="/parametres/payment-account" target="_blank">ce lien</a>
                  </p>
                  <p *ngIf="isAdmin" class="form_item error">Le compte de paiement de cette organisation n'est pas valide
                  </p>
                </ng-template>
              </ng-container>
            </div>
            <div class="form_item full">
              <div class="form_cols">
                <div class="form_item half no_margin">
                  <label for="var">TVA</label>
                  <div class="input_wrap select">
                    <select id="vat" formControlName="taxId">
                      <option *ngFor="let tax of taxes" [value]="tax._id">{{tax.name}}</option>
                    </select>
                    <svg *ngIf="!ticketType" role="img" title="chevron" class="icon-chevron">
                      <use href="assets/images/sprite.svg#icon-chevron"></use>
                    </svg>
                  </div>
                </div>
              </div>
              <p class="description_medium">Une fois le produit créé, vous ne pourrez plus modifier la TVA. <a
                  href="https://www.expert-comptable-tpe.fr/articles/billetterie-spectacle-quelle-tva-appliquer/"
                  target="blank">Quelle
                  TVA choisir ?</a></p>
            </div>
          </ng-container>
          <div class="form_item full no_margin">
            <app-date-interval [preData]="rateForm.value.scheduled" (newDates)="changeDates($event)"
              startText="Début de la vente" endText="Fin de la vente"></app-date-interval>
          </div>
        </div>
        <div formGroupName="tickets" class="form_cols">
          <div class="form_item half">
            <label for="tickets_min">Billets minimum par commande</label>
            <input id="tickets_min" type="number" formControlName="minimumSelectable">
          </div>
          <div class="form_item half">
            <label for="tickets_max">Billets maximum par commande</label>
            <input id="tickets_max" type="number" formControlName="maximumSelectable">
          </div>
        </div>
        <div class="form_cols">
          <div class="form_item half">
            <label for="category">Catégorie</label>
            <div class="input_wrap select">
              <ng-container>
                <select *ngIf="ticketTypeCategories.length" id="category" formControlName="ticketTypeCategoryId">
                  <option *ngFor="let category of ticketTypeCategories" [value]="category._id">{{category.name}}</option>
                </select>
                <select *ngIf="!ticketTypeCategories.length" id="category" disabled>
                  <option selected hidden disabled>Aucune catégorie à sélectionner</option>
                </select>
                <svg role="img" title="chevron" class="icon-chevron">
                  <use href="assets/images/sprite.svg#icon-chevron"></use>
                </svg>
              </ng-container>
            </div>
          </div>
          <div class="form_item full smaller_margin">
            <input id="ticket_limit" type="checkbox" (change)="limitStock = !limitStock" [attr.checked]="limitStock || null">
            <label for="ticket_limit">
              Fixer une limite disponible pour ce produit
              <i class="check">
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </i>
            </label>

          </div>

          <div *ngIf="limitStock" class="form_item half">
            <label for="tickets_stock">Quota</label>
            <input id="tickets_stock" type="number" formControlName="quota">
          </div>
          <div class="form_item full smallest_margin">
            <input id="rate_visible" type="checkbox" class="toggle" formControlName="isVisible">
            <label for="rate_visible">
              Ce produit est visible
              <i class="check">
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </i>
            </label>
          </div>
          <div class="form_item full">
            <input id="rate_available" type="checkbox" class="toggle" formControlName="inTicketOffice">
            <label for="rate_available">
              Ce tarif est disponible au guichet
              <i class="check">
                <svg role="img" title="check" class="check-icon">
                  <use href="assets/images/sprite.svg#icon-check"></use>
                </svg>
              </i>
            </label>
          </div>
          <div (keydown.enter)="$event.stopPropagation()" class="form_item full">
            <label for="description">Description complémentaire</label>
            <app-wysiwyg (changeText)="changeDescriptionValue($event)" [previousValue]="rateForm.value.description">
            </app-wysiwyg>
          </div>
        </div>
        <div class="form_actions right">
          <app-button (clickEvent)="goBack()" text="Annuler" [style]="'border blue'"></app-button>
          <app-button [loadingOff]="loadingState$" [style]="'plain'" type="submit"
            [disabled]="rateForm.invalid || !priceOk" (clickEvent)="createRate()"
            text="{{ticketType ? 'Éditer' : 'Créer'}}">
          </app-button>
          <app-popup *ngIf="error != null" title="Une erreur est survenue" message="{{error}}" popupOpened="true"
            (backEvent)="error = null"></app-popup>
        </div>
      </form>
    </div>
  </div>
</section>